import { createScaleTransition } from "../ScaleTransition";
import { PANEL_CLOSE_MS, PANEL_CLOSE_SCALE, PANEL_OPEN_MS, PANEL_OPEN_SCALE } from "./motion";

// The popover's single open/close transition, plugged into Popover's
// `TransitionComponent` slot (MUI 6.4 has no `slots.transition` on Popover yet).
//
// It replaces the old pair (MUI Grow + the panel's own mount-only `panelReveal`
// keyframe), which layered two entrances and had no exit at all. Recipe:
// transitions-dev "menu dropdown". Open grows from --scale-medium (0.97) and fades in
// on the project entrance curve. Close is shorter (150 vs 250ms) and quieter
// (--scale-tiny, 0.99) on --ease-smooth-out, per the polish open/close asymmetry.
//
// Origin: Popover's `onEntering` handler positions the paper and writes its
// `transform-origin` from the `transformOrigin` prop (top-right, i.e. the bell corner),
// so the scale always grows out of the bell.
//
// The phases, cleanup and reduced-motion handling are the shared ScaleTransition's; this is
// only the dropdown's recipe. Any other anchored Menu/Popover can use it as is.
export const PanelTransition = createScaleTransition(
  { openMs: PANEL_OPEN_MS, closeMs: PANEL_CLOSE_MS, openScale: PANEL_OPEN_SCALE, closeScale: PANEL_CLOSE_SCALE },
  "PanelTransition"
);

export default PanelTransition;
